import { FC } from 'react';

import {
    MessageSquare,
    PackageCheck,
    ScrollText,
    ShieldCheck,
} from 'lucide-react';

import { Card, CardContent } from '../../components/ui/Card';
import { OrderReviewStats } from '../../types';
import { formatReviewScore, getReviewsCountText } from '../../utils';

interface Props {
    reviewStats: OrderReviewStats;
}

export const UserReviewSummary: FC<Props> = ({ reviewStats }) => {
    const metrics = [
        {
            label: 'Усього відгуків',
            value: getReviewsCountText(reviewStats.count),
            icon: MessageSquare,
        },
        {
            label: 'Середня оцінка',
            value: `${formatReviewScore(reviewStats.averageOverallScore)}/5`,
            icon: ShieldCheck,
        },
        {
            label: 'Точність опису',
            value: `${formatReviewScore(reviewStats.averageItemDescriptionScore)}/5`,
            icon: ScrollText,
        },
        ...(reviewStats.packagingRatingsCount > 0
            ? [
                  {
                      label: 'Якість пакування',
                      value: `${formatReviewScore(reviewStats.averagePackagingScore)}/5`,
                      icon: PackageCheck,
                  },
              ]
            : []),
    ];

    return (
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
            {metrics.map((metric) => {
                const Icon = metric.icon;

                return (
                    <Card key={metric.label} className="rounded-2xl">
                        <CardContent className="flex items-start justify-between p-5">
                            <div className="space-y-1">
                                <p className="text-sm text-muted-foreground">
                                    {metric.label}
                                </p>
                                <p className="text-xl font-semibold">
                                    {metric.value}
                                </p>
                            </div>

                            <div className="rounded-full bg-primary/10 p-2">
                                <Icon className="h-4 w-4 text-primary" />
                            </div>
                        </CardContent>
                    </Card>
                );
            })}
        </div>
    );
};
